<template>
  <div v-if="getCrossWithNames.length > 0">
    <span class="h4">{{ $translate('Bigtex5::Template.singleFarbeMore') }}</span>
    <div class="matching-size-hint small my-2" v-if="matchingSize">
      <i class="fa fa-user-circle-o"></i>
      {{ $translate('Bigtex5::Template.crossItemMatchingSize', { size: matchingSize }) }}
    </div>
    <div class="d-flex flex-wrap">
      <template v-for="(item, index) in getCrossWithNames.slice(0, itemsToShow)">
        <div
            :key="item.data.item.id"
            @mouseenter="hoverColor(item.color)"
            @mouseleave="resetHoverColor()"
            class="mb-2"
        >
          <a
              aria-label="cross-image"
              class="cross-image"
              :href="`/${item.data.texts.urlPath}/a-${item.data.item.id}/`"
          >
            <item-store-special
                v-if="item.data.item.storeSpecial|| item.data.variation.bundleType === 'bundle' || item.data.item.itemType === 'set'"
                :store-special="item.data.item.storeSpecial"
                :recommended-retail-price="item.data.prices.rrp"
                :variation-retail-price="item.data.prices.default"
                :special-offer-price="item.data.prices.specialOffer"
                :decimal-count="0"
                :bundle-type="item.data.variation.bundleType"
                :item-type="item.data.item.itemType"
            />
            <img
                :src="item.data.images.all[0].urlSecondPreview"
                class="img-fluid"
                :alt="item.data.texts.name1"
                :title="item.data.texts.name1"
            />
          </a>
        </div>
      </template>

    </div>
    <div>
      <button v-if="itemsToShow < getCrossWithNames.length" @click="showMore" class="btn btn-primary">
        Alle Farben anzeigen
      </button>
    </div>
  </div>
</template>

<script>
import ItemStoreSpecial from "./ItemStoreSpecial.vue";

export default {
  components: {
    ItemStoreSpecial,
  },
  props: {
    crossitems: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      itemsToShow:6,
      hoverColorString: '',
      // wird von VariationSelect gemeldet - die ColorCross-Artikel sind derselbe
      // Artikel in anderen Farben, also gilt dessen Größe unverändert
      matchingSize: null,
    };
  },
  inject: {
    itemId: {
      default: null,
    },
  },
  mounted() {
    window.vueEventHub.$on("bigtex.keptSize.changed", this.onKeptSizeChanged);
    // VariationSelect kann vor uns gemountet haben -> Wert einmal nachfordern
    window.vueEventHub.$emit("bigtex.keptSize.request");
  },
  beforeDestroy() {
    window.vueEventHub.$off("bigtex.keptSize.changed", this.onKeptSizeChanged);
  },
  methods: {
    onKeptSizeChanged(payload) {
      if (payload && payload.itemId === this.itemId) {
        this.matchingSize = payload.size;
      }
    },
    showMore() {
      this.itemsToShow += this.getCrossWithNames.length; // Load  more items
    },
    resetHoverColor() {
      this.hoverColorString = '';
    },
    hoverColor(color) {
      this.hoverColorString = color;
    },
  },
  computed: {
    currentVariation() {
      return this.$store.getters[`${this.itemId}/currentItemVariation`];
    },
    getCrossWithNames() {
      let getCrossWithNames = this.crossitems.flatMap(crossItem =>
          crossItem.data.properties
              .filter(prop => prop.group?.id === 22)
              .map(prop => ({
                color: prop.property.names.name,
                data: crossItem.data,
              }))
      );

      return getCrossWithNames.sort((a, b) => {
        // Extract the storeSpecial objects
        const storeSpecialA = a?.data?.item?.storeSpecial || null;
        const storeSpecialB = b?.data?.item?.storeSpecial || null;

        // Helper function to assign priority
        const getPriority = (storeSpecial) => {
          if (storeSpecial?.id === 3) return 1; // Highest priority
          if (storeSpecial?.id === 2) return 2; // Second priority
          return 3; // Lowest priority
        };

        // Compare priorities
        const priorityA = getPriority(storeSpecialA);
        const priorityB = getPriority(storeSpecialB);

        // Sort by priority first
        if (priorityA !== priorityB) {
          return priorityA - priorityB; // Ascending order based on priority
        }

        // If priorities are the same, sort by data.item.id in descending order
        const itemIdA = a?.data?.item?.id || 0;
        const itemIdB = b?.data?.item?.id || 0;

        return itemIdB - itemIdA; // Descending order based on item.id
      });



    },
    ownColorName() {
      const prop = this.currentVariation.properties.find(p => p.group?.id === 22);
      return prop ? prop.property.names.name : '';
    },
  },
};
</script>
